export default __webpack_public_path__ + "static/media/step-bg.12b978fa.png";